/**
 * Standardizes unit labels for display.
 * 
 * Normalization mapping:
 * - Ft, ft, feet, Feet -> ft
 * - CFS, cfs, ft^3/s, ft3/s, ft/s3, ft/s³ -> cfs
 * - Empty, null, "null", undefined -> empty string
 * 
 * @param {string|null|undefined} unit - The raw unit label
 * @returns {string} The standardized unit label
 */
export function normalizeUnit(unit) {
  if (unit === null || unit === undefined) {
    return '';
  }

  const strUnit = String(unit).trim();
  if (strUnit === '' || strUnit.toLowerCase() === 'null') {
    return '';
  }

  const normalized = strUnit.toLowerCase();

  switch (normalized) {
    case 'ft':
    case 'ft.':
    case 'feet':
      return 'ft';
    case 'cfs':
    case 'ft^3/s':
    case 'ft3/s':
    case 'ft/s3':
    case 'ft/s³':
      return 'cfs';
    default:
      return strUnit; // Return trimmed original if it doesn't match known mappings
  }
}

/**
 * Normalizes all unit patterns inside a text block.
 * e.g. "Elevation (Feet)" -> "Elevation (ft)", "1500 CFS" -> "1500 cfs"
 * 
 * @param {string|null|undefined} text - The raw text
 * @returns {string} The normalized text
 */
export function normalizeText(text) {
  if (!text) return '';
  let str = String(text);
  
  // Replace flow units (case-insensitive)
  str = str.replace(/\b(cfs|ft\^3\/s|ft3\/s|ft\/s3|ft\/s³)\b/gi, 'cfs');
  
  // Replace elevation/level units (case-insensitive)
  str = str.replace(/\b(feet|ft\.)\b/gi, 'ft');
  
  // Replace standalone "Ft"
  str = str.replace(/\bFt\b/g, 'ft');
  
  return str;
}

